import {type TakeFiveHazardAssessmentStepFormValues} from '../../../types'

export const hazardAssessmentDefaultValues: TakeFiveHazardAssessmentStepFormValues = {
  preparedBy: null,
  workToBeDone: '',
  hazards: [],
  hazardsComment: '',
  risks: [],
  risksComment: '',
  eliminateControlHazard: ''
}
